import { coinbaseWallet } from 'wagmi/connectors';
import { createConfig, http, fallback } from 'wagmi';
import { getChainsForEnvironment } from './supportedChains';

/**
 * Creates a fallback transport for a given chain by mapping over its
 * configured RPC endpoints and wiring them together using fallback.
 *
 * Ref: https://wagmi.sh/react/api/transports/fallback
 *
 * @param chain - The chain object from our supported chains configuration.
 * @returns A transport instance constructed via fallback.
 */
function createFallbackTransportForChain(chain: {
  id: number;
  rpcUrls: { default: { http: string[] } };
}) {
  return fallback(chain.rpcUrls.default.http.map((url) => http(url)));
}

export function createWagmiConfig() {
  const chains = getChainsForEnvironment();

  // Build a transports object for each chain in our configuration
  const transports = chains.reduce<Record<number, ReturnType<typeof fallback>>>((acc, chain) => {
    acc[chain.id] = createFallbackTransportForChain(chain);
    return acc;
  }, {});

  return createConfig({
    ssr: true,
    chains: chains,
    transports: transports,
    connectors: [
      coinbaseWallet<'4'>({
        appName: 'Verified Pools',
      }),
    ],
    cacheTime: 5_000,
    pollingInterval: 5_000,
    batch: {
      multicall: {
        batchSize: 1024 * 256, // 256 KB
        // throttling to avoid rate limit
        wait: 500,
      },
    },
  });
}
